import { useEffect, useState } from "react";
import { Trash2, MailOpen } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

export default function Messages() {
  const [messages, setMessages] = useState(null);

  const load = () =>
    api.get("/admin/messages").then((r) => setMessages(r.data)).catch((e) => toast.error(formatApiError(e)));

  useEffect(() => {
    load();
  }, []);

  const markRead = async (m) => {
    await api.patch(`/admin/messages/${m.id}/read`);
    load();
  };

  const remove = async (m) => {
    if (!window.confirm(`Delete message from ${m.name}?`)) return;
    await api.delete(`/admin/messages/${m.id}`);
    toast.success("Message deleted");
    load();
  };

  if (!messages) return <div className="py-20 text-center text-sm text-neutral-500">Loading messages...</div>;

  return (
    <div data-testid="messages-page">
      <h1 className="font-display text-4xl font-medium text-white">Messages</h1>
      <p className="mt-2 text-sm font-light text-neutral-400">Enquiries sent through the website contact form.</p>

      {messages.length === 0 ? (
        <div data-testid="messages-empty" className="mt-8 border border-dashed border-white/15 py-20 text-center text-sm text-neutral-500">
          No enquiries yet.
        </div>
      ) : (
        <div className="mt-8 space-y-4">
          {messages.map((m, i) => (
            <div
              key={m.id}
              data-testid={`message-card-${i}`}
              className={`border p-6 transition-colors ${m.read ? "border-white/10 bg-[#0C0C0C]" : "border-[#D4AF37]/40 bg-[#D4AF37]/5"}`}
            >
              <div className="flex flex-wrap items-start justify-between gap-4">
                <div>
                  <div className="flex items-center gap-3">
                    <span data-testid={`message-name-${i}`} className="font-display text-xl text-white">{m.name}</span>
                    {!m.read && <span className="bg-[#D4AF37] px-2 py-0.5 text-[9px] uppercase tracking-widest text-black">New</span>}
                  </div>
                  <div className="mt-1 text-xs text-neutral-400">
                    <a href={`mailto:${m.email}`} className="text-[#D4AF37]/90 hover:text-[#D4AF37]">{m.email}</a>
                    {m.phone && <span className="ml-3">{m.phone}</span>}
                  </div>
                  <div className="mt-1 text-[10px] uppercase tracking-[0.25em] text-neutral-500">
                    {m.category} · {m.created_at ? new Date(m.created_at).toLocaleString("en-IN") : ""}
                  </div>
                </div>
                <div className="flex gap-2">
                  {!m.read && (
                    <button data-testid={`message-read-${i}`} onClick={() => markRead(m)} className="flex items-center gap-2 border border-white/15 px-3 py-2 text-xs text-neutral-300 transition-colors hover:border-[#D4AF37] hover:text-[#D4AF37]">
                      <MailOpen className="h-4 w-4" strokeWidth={1.5} /> Mark Read
                    </button>
                  )}
                  <button data-testid={`message-delete-${i}`} onClick={() => remove(m)} className="border border-white/15 p-2 text-neutral-300 transition-colors hover:border-red-500 hover:text-red-400" aria-label="Delete">
                    <Trash2 className="h-4 w-4" strokeWidth={1.5} />
                  </button>
                </div>
              </div>
              <p data-testid={`message-body-${i}`} className="mt-4 text-sm font-light leading-relaxed text-neutral-300">{m.message}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
